export default __webpack_public_path__ + "static/RoxyBanner-4cdaaad440a7da8aba4d3b60a4debf26.png";